module.exports = __webpack_public_path__ + "img/font_times-new-roman.a9ad000.svg";